// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1d883b36","732":"0609941d","977":"9aa5832b"}[chunkId] + ".chunk.js";
};